<!-- 1-1-2 页面 -->
<template>
  <div class="app">
    <PanelV2
      type="w5"
      title="Create your BDO Merchant account"
      @nextClick="commitData"
      @prevClick="toIndex"
      customPrevClick
    >
      <template v-slot:content-solt>
        <BDOMerchantForm
          v-model="formData"
          ref="appForm"
          :toggleContact="toggleContact"
        />
      </template>
    </PanelV2>
    <DialogV1
      v-if="showDialog"
      @closeDialog="closeDialog"
      @doAgree="doAgree"
      :needDisagree="true"
      :btn_name="'I Agree'"
    >
      <template v-slot:dia-content-title><div :class="dialogTitle ==='MERCHANT AGREEMENT' ? 'text_align' : ''">{{ dialogTitle }}</div></template>
      <template v-slot:dia-content-solt>
        <div class="agree-body">
          <div v-if="!isPrivacy">
            <div v-html="privacy">{{privacy}}</div>
          </div>
          <div v-else>
            <!-- <div v-for="(item,index) in agreeContent" :key="index" class="agreeBox">
              <img :src="item" />
            </div> -->
            <div v-html="merchantAgreement">{{merchantAgreement}}</div>
          </div>
        </div>
      </template>
      <template v-slot:dia-content-cbc>
        I have read,understood and agree to the
        <strong>{{ dialogTitle === 'MERCHANT AGREEMENT' ? 'Merchant Agreement' : dialogTitle }}</strong> declared herein</template
      >
    </DialogV1>
    <ModalDisagree
      v-if="showModal"
      @toBack="toBack"
      @doConfirm="doConfirm"
      :lbtnName="'Back'"
      :rbtnName="'Confirm'"
    >
      <template v-slot:modal_title
        >By disagreeing to the {{ dialogTitle === 'MERCHANT AGREEMENT' ? 'Merchant Agreement' : dialogTitle }}, you are<br/>
        discontinuing your
        <strong> BDO Merchant</strong> application</template
      >
    </ModalDisagree>
  </div>
</template>

<script>
  import DialogV1 from "./pc/components/DialogV1";
  import ModalDisagree from "./pc/components/ModalDisagree";
  import BDOMerchantForm from "./pc/forms/BDOMerchantForm.val";
  import {privacy} from "./common-data/privacy-policy";
  import { merchantAgreement } from "./common-data/merchant-agreement";
  import API from "@/api";
  import MD5 from '@/plugins/crypto-md5.js'
  import {getInitFormData,} from './pc/forms/utils.js';

  export default {
    name: 'App',
    components: {
      BDOMerchantForm,
      DialogV1,
      ModalDisagree
    },
    mounted() {
      window.loadI18NData('en', () => {});

      this.formRules['mchPassword'].push({
        validator: this.validatePass,
        trigger: 'change'
      });
      this.formRules['confirmPassword'].push({
        validator: this.validatePass2,
        trigger: 'change'
      });
    },
    data(){
      return{
        toggleContact: false,
        formData: getInitFormData({
        }),
        showDialog: false,
        showModal: false,
        dialogTitle: '',
        isAgree: false,
        isPrivacy: false,
        privacy: privacy,
        merchantAgreement: merchantAgreement,
        localTime: '',
      }
    },
    methods: {
      // 验证密码
      validatePass(rule, value, callback) {
        const rules = /[`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、/]/im
        if (!(/[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && rules.test(value)) || (value.length < 8 || value.length > 16)) {
          callback(new Error(`Enter New Password`));
        } else {
          callback();
        }
      },
      // 验证密码 一致性校验
      validatePass2(rule, value, callback) {
        if (value === '') {
          callback(new Error(`Confirm your password`));
        } else if (value !== this.formData.mchPassword) {
          // console.log(value, this.formData, this.formData.mchPassword)
          callback(new Error('Passwords do not match.'));
        } else {
          callback();
        }
      },
      doConfirm() {
        this.showModal = false;
      },
      toBack() {
        this.showDialog = true;
        this.showModal = false;
      },
      doAgree() {
        if( this.dialogTitle == 'Privacy Policy' ) {
          API.getLocalDate().then(res => {
            if(res.success) {
              const { localTime } = res.obj || {}
              this.localTime = localTime || ''
              this.showDialog = false;
              this.isPrivacy = true;

              setTimeout(()=> {
                this.dialogTitle = 'MERCHANT AGREEMENT'
                this.showDialog = true;
              },500)
            }
          })
        }
        if ( this.dialogTitle == 'MERCHANT AGREEMENT' ) {
          this.showDialog = false;
          this.isAgree = true;
        }
        if(!this.isAgree) {
          this.dialogTitle = 'MERCHANT AGREEMENT'
          setTimeout(()=> {
            this.showDialog = true;
          },500)
        }
        if ( this.isPrivacy && this.isAgree ) {
          this.commitData()
        }
      },
      closeDialog() {
        this.showDialog = false;
        this.showModal = true;
      },
      sendEmail() {
        API.sendEmail({
          token: this.getCookieItem("token"),
        }).then(res => {
          if(res.success) {
            console.log(res)
          }
        })
      },
      login() {
        const formData = this.formData
        API.addBdoMerchant({
          ...formData,
          privacyAgreementTimeStr: this.localTime,
          mchPassword: MD5(String(formData.mchPassword)),
          confirmPassword: MD5(String(formData.mchPassword)),
        }).then(res => {
          if (res.success) {
            this.setCookieItem('token', res.obj.token)
            this.sendEmail()
            this.toNext();
          }
        })
      },
      // 提交数据
      commitData() {
        this.$refs.appForm.$refs.appForm.validate((valid) => {
          if (valid) {
            if(!this.isPrivacy) {
              this.dialogTitle = 'Privacy Policy'
              this.showDialog = true
              return
            }
            if(!this.isAgree) {
              this.dialogTitle = 'MERCHANT AGREEMENT'
              this.showDialog = true
              return
            }
            this.login()
          }
        })
      },
      toIndex(){
        this.goBackAppIndex()
      }
    }
  }
</script>

<style lang="scss" scoped>
.app {
  .el-form-item {
    margin-bottom: 16px ;
  }
  .agreeBox {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
.agree-body {
  word-break: break-word;
  ::v-deep {
    p {
      margin-bottom: 10px;
    }
  }
}
</style>
